import React from 'react';
import PropTypes from 'prop-types';

const InstagramAuth = ({ linked, deauthorize, authorize, wrapperClass, isLoading }) => (
  <div className={wrapperClass}>
    <div className="c-label-new">Link Instagram</div>
    { !linked ? (
      <button
        type="button"
        className="c-btn c-btn--small"
        onClick={authorize}
        disabled={isLoading}
      >
        Link
      </button>
    ) : (
      <button
        type="button"
        className="c-btn c-btn--small"
        onClick={deauthorize}
        disabled={isLoading}
      >
        Unlink
      </button>
    ) }
  </div>
);

InstagramAuth.propTypes = {
  linked: PropTypes.bool,
  deauthorize: PropTypes.func.isRequired,
  authorize: PropTypes.func.isRequired,
  wrapperClass: PropTypes.string,
  isLoading: PropTypes.bool,
};

InstagramAuth.defaultProps = {
  linked: false,
  wrapperClass: '',
  isLoading: false,
};

export default InstagramAuth;
